import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Image,
  Modal,
  Row,
  Table,
  Spinner,
} from "react-bootstrap";
import { TailSpin } from "react-loader-spinner";

// import { userTaleListByType } from "../../../api/taleService";
import { getTales, updateTaleStatus, destroyTale } from "../../api/taleService";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Icon } from "@iconify/react";
import bookimg1 from "../../assets/img/bookimg1.jpg"; // Fallback image
const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";
const THUMB_URL = "https://d2wkfbkx3no0o5.cloudfront.net/";
const OLT_icon = "https://d3bn54rc14fhr4.cloudfront.net/ss.png";

const getImageUrl = (book) => {
  if (book.fileType?.includes("video")) {
    return `${THUMB_URL}${book.thumbnail}`;
  } else {
    return `${MEDIA_URL}${book.file}`;
  }
};

export default function TaleTab() {
  const [searchText, setSearchText] = useState("");
  const [userTaleList, setUserTaleList] = useState([]);
  const [uploadType, setUploadType] = useState("");
  const [tales, setTales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const handleToggleStatus = (id) => {
  //   setData((prevData) =>
  //     prevData.map((item) =>
  //       item.id === id
  //         ? {
  //             ...item,
  //             status: item.status === "Active" ? "Inactive" : "Active",
  //           }
  //         : item
  //     )
  //   );
  // };

  const { userId } = useParams();

  useEffect(() => {
    fetchTales();
  }, []);

  const fetchTales = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getTales();

      if (response.data) {
        // console.log("====22323323232323======response.data", response.data);

        setTales(response.data);
      }
    } catch (error) {
      setError("Error fetching tales");
      console.error("Error fetching tales:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "Title",
      minWidth: "160px",
      selector: (row) => row.ID,
      sortable: true,
      cell: (row) => (
        <>
          <img
            src={getImageUrl(row)}
            className="table_img rounded-circle img-thumbnail me-2"
            alt={row.title}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = row.file ? `${MEDIA_URL}/${row.file}` : OLT_icon;
            }}
            style={{
              width: "50px",
              height: "50px",
              objectFit: "cover",
              marginRight: "10px",
            }}
          />
          {row.title}
        </>
      ),
    },
    {
      name: "User name",
      minWidth: "190px",
      selector: (row) => row.userId.username ? row.userId.username : "N/A",
      sortable: true,
      cell: (row) => (
        <Link
          to={`/admin/view-user/${row.userId._id}?tab=basicinfo`}
          className="text-primary"
          style={{ textDecoration: "none", cursor: "pointer" }}
        >
          {row.userId.username ? row.userId.username : "N/A"}
        </Link>
      ),
    },
    {
      name: "Characters",
      minWidth: "150px",
      selector: (row) =>
        Array.isArray(row.characters) ? row.characters.length : 0,
      sortable: true,
    },
    {
      name: "Date Created",
      minWidth: "180px",
      selector: (row) => row.createdAt,
      sortable: true,
      cell: (row) =>
        new Date(row.createdAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
    },

    {
      name: "Actions",
      width: "150px",
      cell: (row) => (
        <>
          <Link className="btnview" to={`/admin/tale-detail/${row._id}`}>
            <Icon icon="tabler:eye" />
          </Link>
          {/* <Link className="btndelete" onClick={handleShow}>
            <Icon icon="tabler:trash"></Icon>
          </Link> */}
        </>
      ),
    },
  ];
  // const [data, setData] = useState([
  //   {
  //     id: 1,
  //     ID: "#123456",
  //     Title: "Serenade of the Sunset",
  //     Date: "29 May 2025",
  //     status: "Active",
  //   },
  //   {
  //     id: 2,
  //     ID: "#123457",
  //     Title: "Serenade of the Sunset",
  //     Date: "29 May 2025",
  //     status: "Inactive",
  //   },
  //   {
  //     id: 3,
  //     ID: "#123458",
  //     Title: "Serenade of the Sunset",
  //     Date: "29 May 2025",
  //     status: "Active",
  //   },
  //   {
  //     id: 4,
  //     ID: "#123459",
  //     Title: "Serenade of the Sunset",
  //     Date: "29 May 2025",
  //     status: "Inactive",
  //   },
  //   {
  //     id: 5,
  //     ID: "#123460",
  //     Title: "Serenade of the Sunset",
  //     Date: "29 May 2025",
  //     status: "Active",
  //   },
  // ]);

  // Filter data based on search text
  const filteredData = tales
    .filter((item) => {
      if (uploadType) {
        return item.uploadType === uploadType;
      }
      return true;
    })
    .filter((item) => {
      return JSON.stringify(item)
        .toLowerCase()
        .includes(searchText.toLowerCase());
    });
  return (
    <React.Fragment>
      <Card>
        <Card.Body className="bookingtable">
          <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-3">
            <div className="tableselectTypefield">
              <Form.Select
                value={uploadType}
                onChange={(e) => setUploadType(e.target.value)}
              >
                <option value="">All Tales</option>
                <option value="ShortTale">Short Tales</option>
                <option value="UploadTale">Upload Tales</option>
                <option value="AiGeneratedTale">AI Generated Tales</option>
              </Form.Select>
            </div>
            <div className="text-end">
              <input
                type="text"
                placeholder="Search..."
                className="searchfield"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>
          {loading ? (
            <div
              className="text-center py-5"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "120px",
                width: "100%",
              }}
            >
              <TailSpin height={50} width={80} color="#4fa94d" />
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              responsive
              className="custom-table"
            />
          )}
        </Card.Body>
      </Card>
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            onClick={handleClose}
            className="btn btn-primary-outline px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            className="btn btn-primary px-4 min_width110"
            onClick={handleClose}
          >
            Ok
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
